"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useState, useEffect, useRef } from "react";
import { Shirt, Info } from "lucide-react";
export default function Vestimenta() {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);
  return <section id="vestimenta" className="bg-background py-16 px-4">
      <div className="container mx-auto max-w-2xl" ref={containerRef}>
        <h2 className={`text-[2.125rem] font-display font-semibold leading-[1.3] text-center mb-12 transition-all duration-[var(--duration-medium)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} text-primary-dark`}>
          Código de Vestimenta
        </h2>

        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Card className="
              transition-all 
              duration-[var(--duration-medium)] 
              ease-[var(--ease-out-back)] 
              cursor-default 
              group
              shadow-soft
              hover:shadow-medium
              hover:-translate-y-1
              border-none
              rounded-[var(--radius-md)]
              bg-white
              py-0
            ">
            <CardContent className="p-8 flex flex-col gap-8">
              <div className="flex gap-4 items-start" data-index={0}>
                <div className="p-3 rounded-full bg-primary/10 text-primary-dark shrink-0">
                  <Shirt className="w-6 h-6" strokeWidth={2} />
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2 text-primary-dark font-display">
                    Elegante y con estilo
                  </p>
                  <p className="text-foreground text-base leading-relaxed">Evita blanco o tonos similares y deja el chándal en casa. Colores alegres, comodidad y buen rollo son bienvenidos.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-index={1}>
                <div className="p-3 rounded-full bg-secondary/10 text-secondary-dark shrink-0">
                  <Info className="w-6 h-6" strokeWidth={2} />
                </div>
                <div>
                  <p className="text-lg font-semibold mb-2 text-secondary-dark font-display">
                    Nota importante para la ceremonia
                  </p>
                  <p className="text-foreground text-base leading-relaxed">
                    En la Concatedral, las mujeres deberán llevar los <strong>hombros cubiertos</strong>. Esto puede ser con un chal, estola o vestido que los cubra.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}